<template>
    <div class="new-home-ld">
        <dv-flyline-chart-enhanced :config="config" class="dynamic-map"></dv-flyline-chart-enhanced>
        <div class="home-title">
            <img src="../../assets/images/homeLd/logo.png" alt="">
        </div>
        <div class="icon-list">
            <dl @click="toLink(item)" v-for="(item, index) in homeList" :key="index">
                <dt><img :src="item.imgs" alt=""></dt>
                <dd :class="item.isHighlight ? 'highlight' : ''">
                    {{ item.title }}
                </dd>
            </dl>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
            homeList: [
                {
                    imgs: require('../../assets/images/homeLd/icon1_highlight.png'),
                    title: '经营驾驶舱',
                    isHighlight: true,
                    link: 'leadingCockpitMap',
                },
                {
                    imgs: require('../../assets/images/homeLd/icon2_highlight.png'),
                    title: '运营报表',
                    isHighlight: true,
                    link: 'inHome',
                },
                {
                    imgs: require('../../assets/images/homeLd/icon3_highlight.png'),
                    title: '合同审批',
                    isHighlight: true,
                    link: 'contractApproval',
                },
                {
                    imgs: require('../../assets/images/homeLd/icon4_highlight.png'),
                    title: '统计分析',
                    isHighlight: true,
                    link: 'dataBulletin',
                },
                {
                    imgs: require('../../assets/images/homeLd/icon7_highlight.png'),
                    title: '数据快报',
                    isHighlight: true,
                    link: 'dataReport',
                },
                {
                    imgs: require('../../assets/images/homeLd/icon5_normal.png'),
                    title: '三维场站',
                    isHighlight: true,
                    link: '',
                },
                // {
                //     imgs: require('../../assets/images/homeLd/icon6_normal.png'),
                //     title: '知识图谱',
                //     isHighlight: false,
                //     link: '',
                // },
            ],
            config: {
                points: [
                    {
                        name: '北京',
                        coordinate: [0.75, 0.37],
                        icon: {
                            src: require('../../assets/images/homeLd/dot.png'),
                            width: 11,
                            height: 11,
                        },
                    },
                    {
                        name: '河北',
                        coordinate: [0.73, 0.42],
                    },
                    {
                        name: '山东',
                        coordinate: [0.78, 0.48],
                    },
                    {
                        name: '江苏',
                        coordinate: [0.83, 0.55],
                    },
                    {
                        name: '安徽',
                        coordinate: [0.78, 0.58],
                    },
                    {
                        name: '河南',
                        coordinate: [0.72, 0.53],
                    },
                    {
                        name: '山西',
                        coordinate: [0.68, 0.45],
                    },
                    {
                        name: '内蒙古',
                        coordinate: [0.64, 0.35],
                    },
                    {
                        name: '蒙古国',
                        coordinate: [0.55, 0.22],
                    },
                    {
                        name: '四川',
                        coordinate: [0.5, 0.66],
                    },
                ],
                lines: [
                    {
                        source: '北京',
                        target: '河北',
                    },
                    {
                        source: '北京',
                        target: '山东',
                    },
                    {
                        source: '北京',
                        target: '江苏',
                    },
                    {
                        source: '北京',
                        target: '安徽',
                    },
                    {
                        source: '北京',
                        target: '河南',
                    },
                    {
                        source: '北京',
                        target: '山西',
                    },
                    {
                        source: '北京',
                        target: '内蒙古',
                    },
                    {
                        source: '北京',
                        target: '蒙古国',
                    },
                    {
                        source: '北京',
                        target: '四川',
                    },
                ],
                flyline: {
                    orbitColor: '#F0F',
                    color: '#FFF',
                },
                icon: {
                    show: true,
                    src: require('../../assets/images/homeLd/dot.png'),
                    height: 7,
                    width: 7,
                },
                text: {
                    color: '#FFF',
                    show: true,
                    fontSize: 10,
                    offset: 100,
                },
                bgImgSrc: require('../../assets/images/homeLd/maps.png'),
                // bgImgSrc: 'http://www.51wendang.com/pic/bf7ec19ed908de06649caac1/1-810-jpg_6-1080-0-0-1080.jpg',
            },
        };
    },
    methods: {
        toLink(item) {
            if (item.link) {
                this.$router.isBack = 2;
                this.$router.push({ name: item.link });
            } else {
                Toast({
                    message: '数据对接中',
                    position: 'bottom',
                });
            }
        },
    },
    mounted() {
        // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //     this.$router.isBack = 2;
        //     this.$router.push({ name: 'inHome' });
        // }
    },
};

</script>
<style lang='stylus' scoped>
.new-home-ld
    width 100%
    height 100%
    background: url('../../assets/images/homeLd/new-bg.jpg');
    background-repeat no-repeat
    background-size cover
    position relative
    .home-title
        position absolute
        width 100%
        text-align center
        top 50rpx
        img
            width 80%
    .dynamic-map
        width 100%
        height 150rpx
        margin-top 100rpx
    .icon-list
        display flex
        flex-wrap wrap
        /*justify-content center*/
        align-items center
        position absolute
        bottom 130rpx
        dl
            width 33.3%
            display flex
            flex-direction column
            justify-content center
            align-items center
            dt
                width 100%
                text-align center
                img
                    width 80rpx
            dd
                font-size 12rpx
                color #117D95
            .highlight
                color #4FDFFE
</style>
